import React from "react";
import { useQuery } from "@apollo/client";
import gql from "graphql-tag";
import { Select } from "components/base/Form";

const FETCH_SHIPMENT_STATUS_INFO = gql`
  query FETCH_SHIPMENT_STATUS_INFO {
    shipmentStatusInfo
  }
`;

const ShipmentStatusOptions = ({ value, onSelected, ...rest }) => {
  const { data } = useQuery(FETCH_SHIPMENT_STATUS_INFO);

  if (!data) return <div className="text-gray-500">Loading...</div>;

  const options = JSON.parse(data.shipmentStatusInfo);

  return (
    <Select
      value={value}
      onChange={(event) => onSelected(event.target.value)}
      {...rest}
    >
      <option value="">All status</option>
      {Object.keys(options).map((key) => (
        <option value={key} key={key}>
          {key}
        </option>
      ))}
    </Select>
  );
};

export default ShipmentStatusOptions;
